import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { RoleService } from "../../../../auth/service/role.service";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { IDatatableConfig } from "app/auth/models/datatable";
import { IRole, IRoleForm } from "app/auth/models";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-roles-list",
  templateUrl: "./roles-list.component.html",
  styleUrls: ["./roles-list.component.scss"],
})
export class RolesListComponent implements OnInit {
  public config: IDatatableConfig;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public newRole: string = "";
  public newOrder: number;
  public currentRoles: IRole;
  public roles: IRole[];
  public showErrors: boolean = false;

  constructor(
    public _roleService: RoleService,
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.MENU.ROLES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.ROLES,
            isLink: false,
          },
        ],
      },
    };

    await this.loadRoles();
  }

  async loadRoles() {
    this.roles = await this._roleService.getList();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  rolesList() {
    let items: IRole[] = this.roles;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.roles.filter((item: IRole) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }
    return items;
  }

  async deleteRole(currentRole) {
    if (!this._authenticationService.hasCapability("delete_role")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentRole.name;
    if (currentRole.users < 1) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._roleService
            .delete(currentRole.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadRoles();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_ROLE_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    } else {
      await this._utilService.showSWALError({ text: "USED_ROLE_TEXT" });
    }
  }

  async addRole() {
    if (!this._authenticationService.hasCapability("create_role")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.newRole) {
      this.newRole = this.newRole.trim();
    }

    if (this.newRole.length < 1 || this.newOrder < 1) {
      this.showErrors = true;
      return false;
    }

    let data: IRoleForm = {
      name: this.newRole,
      order: this.newOrder,
    };

    this._utilService.showLoading();
    await this._roleService
      .create(data)
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_ROLE" });
        this._modalService.dismissAll();
        this.loadRoles();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_ROLE_UPLOAD" });
      });
  }

  async editRole() {
    if (!this._authenticationService.hasCapability("edit_role")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentRoles.name) {
      this.currentRoles.name = this.currentRoles.name.trim();
    }

    if (!this.currentRoles.name || this.currentRoles.name.length < 1 || !this.currentRoles.order || this.currentRoles.order < 0) {
      this.showErrors = true;
      return false;
    }

    let data: IRoleForm = {
      name: this.currentRoles.name,
      order: this.currentRoles.order,
    };

    this._utilService.showLoading();
    await this._roleService
      .update(this.currentRoles.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ROLE" });
        this._modalService.dismissAll();
        this.loadRoles();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_ROLE_EDIT" });
      });
  }

  public modalOpen(whichModal, role) {
    this.showErrors = false;
    this.newRole = "";
    this.newOrder = null;
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
    this.currentRoles = JSON.parse(JSON.stringify(role));
  }
}
